import moment from "moment";

export function format(date, format = 'YYYY年MM月DD日') {
    return moment(date).format(format);
}